<script context="module">
  import BlockQuote from "$lib/contentTypes/BlockQuote.svelte";
  import Contributors from "$lib/contentTypes/Contributors.svelte";
  import FundraisingGraph from "$lib/contentTypes/FundraisingGraph.svelte";
  import ItemPreviewList from "$lib/contentTypes/ItemPreviewList.svelte";
  import TopicHeaderComponent from "$lib/contentTypes/TopicHeaderComponent.svelte";
  import LinkComponent from "$lib/contentTypes/LinkComponent.svelte";
  import HeroComponent from "$lib/contentTypes/HeroComponent.svelte";
  import Embed from "$lib/contentTypes/Embed/Embed.svelte";
  import FreeRichTextComponent from "$lib/contentTypes/FreeRichTextComponent.svelte";
  import ImageComponent from "$lib/contentTypes/ImageComponent.svelte";
  import ImageGroup from "$lib/contentTypes/ImageGroup.svelte";
  import Menu from "$lib/contentTypes/Menu.svelte";
  import CallToActionComponent from "$lib/contentTypes/CallToActionComponent.svelte";
  import ContentGroup from "$lib/contentTypes/ContentGroup.svelte";
  import SectionComponent from "$lib/contentTypes/SectionComponent.svelte";
  import NavTarget from "$lib/contentTypes/NavTarget.svelte";
  import LayoutComponent from "$lib/contentTypes/LayoutComponent.svelte";
  import SocialShares from "$lib/contentTypes/SocialShares.svelte";
  import EmailSignupForm from "$lib/contentTypes/EmailSignupForm.svelte";
  import FundraiseUpElement from "$lib/contentTypes/FundraiseUpElement.svelte";

  export const COMPONENT_MAP = {
    blockQuote: BlockQuote,
    callToActionComponent: CallToActionComponent,
    contributors: Contributors,
    emailSignup: EmailSignupForm,
    embed: Embed,
    fundraisingGraph: FundraisingGraph,
    fundraiseUpElement: FundraiseUpElement,
    heroComponent: HeroComponent,
    imageComponent: ImageComponent,
    imageGroup: ImageGroup,
    itemPreviewList: ItemPreviewList,
    layout: LayoutComponent,
    linkComponent: LinkComponent,
    menu: Menu,
    navTarget: NavTarget,
    topicHeaderComponent: TopicHeaderComponent,
    sectionComponent: SectionComponent,
    contentGroup: ContentGroup,
    socialShares: SocialShares
  };

  export const LAYOUT_COMPONENT_MAP = {
    blockQuote: BlockQuote,
    callToActionComponent: CallToActionComponent,
    contentGroup: ContentGroup,
    emailSignup: EmailSignupForm,
    embed: Embed,
    freeRichTextComponent: FreeRichTextComponent,
    fundraiseUpElement: FundraiseUpElement,
    imageComponent: ImageComponent,
    imageGroup: ImageGroup
  };

  //These components are used in RichText and don't import other elements
  export const BASE_COMPONENT_MAP = {
    blockQuote: BlockQuote,
    imageComponent: ImageComponent,
    embed: Embed,
    linkComponent: LinkComponent
  };
</script>
